import React from 'react';
import { Link, browserHistory } from 'react-router';
import { Input, DropDown, TextArea, InputNumber } from 'components/tt-forms/common';
import { ShowIf } from 'components/utils';
import { Dialog } from "@blueprintjs/core";
import DataTable from 'components/data-table';
import { header } from 'constants/table';
import { Danhmuc, ThanhTra } from 'api';
import { RowItemDanhSachThemMoiThanhTra } from 'modules/thanh-tra/datatable';
import { RowItemKetQuaTimKiemThanhTra, DataTableMultipleSelect } from 'modules/thanh-tra/datatable';
import { Toastr } from 'modules/toastr';
import {
  DropDownChonLinhVucThanhTraMultiple,
  DropDownMulipleUse
} from 'components/tt-forms';
import { get, isEmpty, isArray, includes } from 'lodash';
import { msg } from "constants/message";
import { Reception } from 'api';
import { checkServerLive, LimitFileSize } from 'constants/config';
import { downloadExcel } from "constants/downloadExcel";
import { downloadFile } from 'components/utils';
import classnames from 'classnames';
import { API_URL } from 'constants/config';
import { exportExcel } from "constants/exportExcel";
import './style.scss';
import { DuLieuHeThong } from 'api';
import { DropDownMultipleSelect } from '../../../tt-forms/common';

class ThemMoiDoiTuongThanhTra extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
    this.state = {
      checked: false,
      // checkDonViPhoiHop: false,
      namThanhTra: '',
      duongDan: '',
      tenFile: '',
      isOpen: false,
      isOpenThongBao: false,
      getTenDoiTuong: [],
      getDSDTDeXuatXuLys: [],
      idPushCoQuan: [],
      isOpenDT: false,
      loading: false,
      isOpenThanhTra: false,
      linhVucId: '',
      nhomDoiTuongThanhTraId: '',
      tuKhoa: '',
      maSoThue: '',
      quanHuyenId: '',
      dsQuanHuyen: [],
      phuongXaId: '',
      dsPhuongXa: [],
      diaChi: '',
      hinhThucKHTTList: [],
      dataLinhVucThanhTra: [],
      type: this.props.type,
      showDoiTuongThanhTra: false,
      danhSachDonViPhoiHop: [],
      dataDoiTuongViPhamHienTai: [],
      doiTuongThanhTra: '',
      donViPhoiHop: '',
      kyThanhTra: '',
      doiTuongThanhTras: [],
      data: {
        doiTuongThanhTraInfo: {},
        ten: '',
        doiTuongThanhTra: '',
        doiTuongThanhTras: [],
        tenNhieuDoiTuongThanhTra: '',
        thoiGianTienHanh: '',
        cuocThanhTraNhieuDoiTuong: false,
        tenMotDoiTuongThanhTra: '',
        cuocThanhTraNhieuDoiTuongList: {
          text: `${this.checkIsKiemTra() ? 'Kiểm tra' : 'Thanh tra'} nhiều đối tượng`,
          type: 'true'
        },
        linhVucThanhTraList: [],
        thucHienPhapLuatVeThanhTraList: [],
        chiTietLinhVuc: '',
        hinhThucThanhTraChuyenNganhInfo: {
          text: '',
          type: ''
        },
        chucNangCuocThanhTraInfo: {
          text: 'Hành Chính',
          type: 'HANH_CHINH'
        },
        donViPhoiHop: '',
        donViChuTri: this.userInfo.donViId,
        tenDonViChuTriInfo: this.userInfo.tenCoQuanQuanLy,
        donViChuTriInfo: {
          coQuanQuanLyId: this.userInfo.donViId,
          ten: this.userInfo.tenCoQuanQuanLy
        },
      },
      noiDungThanhTra: '',
      thoiHanThanhTra: '',
      kyTruocChuyenSang: false,
      linhVucList: [],
      nhomDTList: [],
      dataDonViChuTri: [],
      hinhThucThanhTraChuyenNganhList: [],
      chucNangKeHoachThanhTra: '',
      pageData: {
        number: 0,
        size: 10,
        totalElements: 0
      },
      ketQuaTimKiemList: [],
      tableLoading: false,
      doiTuongSelectedList: [],
      checkAll: false,
      totalSelectedList: [],
      doiTuongThanhTraImport: [],

      //confirm
      confirmDoiTuongViPham: false,
      tenDoiTuongViPhamConfirm: '',
      confirmDoiTuongLienQuan: false,
      tenDoiTuongLienQuanConfirm: '',
      thucHienPhapLuatVeThanhTraListCombobox: [],
      cuocThanhTraNhieuDoiTuongList: [
        {
          giaTri: 'true',
          ten: `${this.checkIsKiemTra() ? 'Kiểm tra' : 'Thanh tra'} nhiều đối tượng`
        },
        {
          giaTri: 'false',
          ten: `${this.checkIsKiemTra() ? 'Kiểm tra' : 'Thanh tra'} một đối tượng`
        },
      ],
      doiTuongSelected: [],
      newTempDoiTuongSelected: [],
      loadingImport: false,
      errorImport: false,
      numberUnsuccess: 0,
      base64Content: '',
      fileName: '',
      mineType: '',
      validLinhVucThanhTra: true,
    }
  }

  componentDidMount() {
    this.getLinhVuc();
    this.getNhomDoiTuong();
    this.getDonViChuTri();
    this.getHinhThucThanhTraChuyenNganh();
    this.getThucHienPhapLuatVeTT();
    this.determinativeVaiTro();
    this.getChucNangCuocThanhTra();
    this.getHinhThucKeHoachThanhTra();
    this.getLinhVucThanhTra();
    this.getDoiTuongThanhTra();
    this.getDSDTDeXuatXuLy();
    this.getQuanHuyen();
  }

  getDSDTDeXuatXuLy() {
    ThanhTra.actions.getDanhSachDoiTuongDaDeXuatXuLy.request({ cuocThanhTraId: 0 }).then(res => {
      let getDSDTDeXuatXuLys = [];
      if (res && res.data) {
        res.data.map(item => {
          if (item) {
            getDSDTDeXuatXuLys.push(item.dttt.id);
          }
        });
      }
      this.setState({ getDSDTDeXuatXuLys });
    });
  }

  determinativeVaiTro() {
    if (typeof this.userInfo == 'undefined') {
      browserHistory.push('/');
    } else {
      this.state.data.donViChuTri = this.userInfo.donViId
    }
  }

  getLinhVucThanhTra() {
    ThanhTra.actions.getLinhVucThanhTra.request().then(res => {
      if (res.data) {
        this.setState({
          dataLinhVucThanhTra: res.data
        })
      }
    })
  }

  getHinhThucKeHoachThanhTra() {
    ThanhTra.actions.getHinhThucKeHoachThanhTra.request().then(res => {
      if (res.data) {
        this.state.hinhThucKHTTList = res.data;
      } else {
        this.state.hinhThucKHTTList = [];
      }
      this.setState({ ...this.state });
    });
  }

  showDoiTuongThanhTra() {
    this.setState({
      showDoiTuongThanhTra: true
    })
  }

  hideDoiTuongThanhTra() {
    this.setState({
      showDoiTuongThanhTra: false
    })
  }
  setDoiTuongViPhamHienTai(data) {
    this.setState({
      dataDoiTuongViPhamHienTai: data
    })
  }

  handleConfirmDoiTuongViPham(state) {
    let data = [...this.state.dataDoiTuongViPhamHienTai];
    let dataFilter = data.filter(item => {
      return state.ten == item.ten
    })

    if (dataFilter.length > 0) {
      this.setState({
        confirmDoiTuongViPham: true,
        tenDoiTuongViPhamConfirm: state.ten
      })
      return true
    } else {
      return false
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.data) {
      this.state.data = {};
      this.state.data = {
        ...nextProps.data,
        donViChuTriInfo: { ...nextProps.data.donViChuTriInfo },
        linhVucThanhTraInfo: { ...nextProps.data.linhVucThanhTraInfo },
        doiTuongThanhTras: nextProps.data.doiTuongThanhTras ? [...nextProps.data.doiTuongThanhTras] : [],
        hinhThucThanhTraChuyenNganhInfo: { ...nextProps.data.hinhThucThanhTraChuyenNganhInfo },
        thucHienPhapLuatVeThanhTraInfo: { ...nextProps.data.thucHienPhapLuatVeThanhTraInfo },
      };
      this.state.chucNangKeHoachThanhTra = nextProps.data.chucNangKeHoachThanhTra || '';
      let arrDv = nextProps.data.donViPhoiHop ? nextProps.data.donViPhoiHop.split(',') : [];
      this.state.danhSachDonViPhoiHop = [];
      arrDv.map(item => {
        this.state.danhSachDonViPhoiHop.push({ ten: item });
      });
      this.setState({ ...this.state });
    }
  }

  getDonViChuTri() {
    ThanhTra.actions.getDonViChuTri.request().then(res => {
      if (res.data._embedded) {
        this.setState({
          dataDonViChuTri: res.data._embedded.coQuanQuanLies
        })
      }
    })
  }

  getHinhThucThanhTraChuyenNganh() {
    ThanhTra.actions.getHinhThucThanhTraChuyenNganh.request().then(res => {
      if (res.data) {
        this.setState({
          hinhThucThanhTraChuyenNganhList: res.data
        });
      }
    });
  }

  getThucHienPhapLuatVeTT() {
    ThanhTra.actions.getThucHienPhapLuatVeTT.request().then(res => {
      if (res.data) {
        this.setState({
          thucHienPhapLuatVeThanhTraListCombobox: res.data
        });
      }
    });
  }

  suggesttion(dataSearch) {
    this.setState({
      isSearch: true
    }, () => {
      let params = {
        tuKhoa: dataSearch
      }

      if (this.state.doiTuongThanhTra) {
        params.doiTuongIds = this.state.doiTuongThanhTra
      }
      Danhmuc.actions.getDoiTuongThanhTra.request(params).then(res => {
        if (res.data._embedded) {
          this.setState({
            dataSuggest: res.data._embedded.doiTuongThanhTras,
            isSearch: false
          })
        } else {
          this.setState({
            dataSuggest: [],
            isSearch: false
          })
        }
      })
    })
  }

  getDoiTuongThanhTra() {
    let d = new Date();
    let getNamTT = d.getFullYear() + 1;
    ThanhTra.actions.getDoiTuongThanhTra.request({ namThanhTra: getNamTT }).then(res => {
      if (res.data._embedded) {
        this.setState({
          dataDoiTuongThanhTra: res.data._embedded.doiTuongThanhTras
        })
      }
    })
  }

  getQuanHuyen() {
    DuLieuHeThong.actions.getQuanHuyen.request().then(res => {
      if (res.data._embedded) {
        this.setState({
          dsQuanHuyen: res.data._embedded.donViHanhChinhs
        })
      }
    })
  }

  getPhuongXa(quanHuyenId = undefined) {
    if (quanHuyenId) {
      DuLieuHeThong.actions.getPhuongXa.request(null, { cha: quanHuyenId }).then(res => {
        this.setState({
          dsPhuongXa: get(res, 'data._embedded.donViHanhChinhs') || []
        })
      })
    }
  }

  getLinhVuc() {
    Danhmuc.actions.getLinhVucDoiTuongThanhTra.request().then(res => {
      if (res.data && res.data._embedded) {
        this.state.linhVucList = res.data._embedded.linhVucDoiTuongThanhTras;
      } else {
        this.state.linhVucList = [];
      }
      this.setState({ ...this.state });
    })
  }

  getNhomDoiTuong() {
    ThanhTra.actions.getNhomDoiTuongThanhTras.request().then(res => {
      let nhomDTList = [];
      if (res.data && res.data._embedded) {
        nhomDTList = res.data._embedded.nhomDoiTuongThanhTras;
      }
      this.setState({ nhomDTList });
    });
  }

  changeCheckbox(e) {
    this.state.data[e.target.name] = e.target.checked
    this.setState({ ...this.state });
  }

  timKiem(statusTimKiem) {
    this.state.checkAll = false;
    let d = new Date();
    let getNamTT = d.getFullYear() + 1;
    const pageData = {
      page: this.state.pageData.number,
      size: this.state.pageData.size,
      sort: 'ngaySua,desc',
    };
    let params = {
      pageData,
      namThanhTra: getNamTT
    };

    if (statusTimKiem) {
      params.pageData.page = 0;
    }

    if (!isEmpty(this.state.doiTuongThanhTras)) {
      const idsDoiTuong = this.state.doiTuongThanhTras.map(item => item.id);
      this.state.doiTuongSelectedList.forEach(item => {
        idsDoiTuong.push(item.doiTuongThanhTraId);
      });
      params.idDoiTuongDaCoCuocs = idsDoiTuong;
    } else {
      const idsDoiTuong = [];
      this.state.doiTuongSelectedList.forEach(item => {
        idsDoiTuong.push(item.doiTuongThanhTraId);
      });
      params.idDoiTuongDaCoCuocs = idsDoiTuong;
    }

    if (this.state.tuKhoa) {
      params.tenDoiTuong = this.state.tuKhoa;
    }
    if (this.state.linhVucId) {
      params.linhVucId = this.state.linhVucId;
    }
    if (this.state.nhomDoiTuongThanhTraId) {
      params.nhomDoiTuongThanhTraId = this.state.nhomDoiTuongThanhTraId;
    }
    if (this.state.diaChi) {
      params.tuKhoa = this.state.diaChi;
    }
    if (this.state.quanHuyenId) {
      params.quanHuyenId = Number(this.state.quanHuyenId);
    }
    if (this.state.phuongXaId) {
      params.phuongXaId = Number(this.state.phuongXaId);
    }
    if (!isEmpty(this.state.maSoThue)) {
      params.maSoThue = this.state.maSoThue;
    }

    this.setState({ tableLoading: true });
    Danhmuc.actions.doiTuongThanhTraChuaCoCuoc.request(null, params).then(res => {
      if (res.data._embedded) {
        let data = get(res, 'data._embedded.doiTuongThanhTras');
        if (!isEmpty(this.state.totalSelectedList) && isArray(this.state.totalSelectedList)) {
          const newData = data.map(item => {
            this.state.totalSelectedList.forEach(itemDoiTuong => {
              if (item.doiTuongThanhTraId === itemDoiTuong.doiTuongThanhTraId) {
                item.selected = true;
              }
            });
            return item;
          });
          data = newData;
        }
        this.setState({
          ketQuaTimKiemList: data,
          pageData: res.data.page,
          tableLoading: false
        });
      } else {
        this.setState({
          ketQuaTimKiemList: [],
          pageData: {
            number: 0,
            size: 10,
            totalElements: 0
          },
          tableLoading: false
        });
      }
    });
  }

  closeDialog(name) {
    const newTempDoiTuongSelected = [];
    const doiTuongSelectedList = [];
    this.setState({
      newTempDoiTuongSelected,
      doiTuongSelectedList,
      [name]: false
    });
  }

  closeDialogThongBao() {
    this.setState({
      isOpenThongBao: false
    })
  }

  openDialog() {
    this.timKiem(true);
    this.state.totalSelectedList = [];
    this.setState({
      isOpen: true
    });
  }

  openDialogThanhTra() {
    this.setState({
      isOpenThanhTra: true,
      validLinhVucThanhTra: true,
    });
  }

  onChangeMaSoThue(e) {
    this.state.maSoThue = e.target.value;
  }

  onChangeTuKhoa(e) {
    this.state.tuKhoa = e.target.value;
  }

  onChangeDiaChi(e) {
    this.state.diaChi = e.target.value;
  }

  onChange(name, e) {
    let state = this.state;
    this.props.validators['thanhTra'] = [];
    if (name == 'ten') {
      state.data.ten = e.target.value;
    } else if (name == 'chiTietLinhVuc') {
      state.data.chiTietLinhVuc = e.target.value;
    } else if (name == 'linhVucId') {
      state.linhVucId = e.target.value;
    } else if (name == 'nhomDoiTuongThanhTraId') {
      state.nhomDoiTuongThanhTraId = e.target.value;
    } else if (name == 'tenNhieuDoiTuongThanhTra') {
      state.data.tenNhieuDoiTuongThanhTra = e.target.value;
    } else if (name == 'doiTuongThanhTra') {
      state.data.doiTuongThanhTra = e.target.value;
    } else if (name == 'donViPhoiHop') {
      state.donViPhoiHop = e.target.value;
    } else if (name == 'phamViThanhTra') {
      state.kyThanhTra = e.target.value;
    } else if (name == 'thoiGianTienHanh') {
      state.data.thoiGianTienHanh = e.target.value;
    } else if (name == 'thoiHanThanhTra') {
      state.thoiHanThanhTra = e.target.value;
    } else if (name == 'noiDungThanhTra') {
      state.noiDungThanhTra = e.target.value;
    } else if (name == 'donViChuTri') {
      state.data.donViChuTri = e.target.value;
      ThanhTra.actions.getDonViChuTri.request().then(res => {
        if (res.data && res.data._embedded) {
          res.data._embedded.coQuanQuanLies.map(item => {
            if (item.coQuanQuanLyId == e.target.value) {
              state.data.donViChuTriInfo.ten = item.ten
            }
          });
        }
      });
    } else if (name == 'chucNangCuocThanhTra') {
      state.data.chucNangCuocThanhTraInfo.type = e.target.value;
    } else if (name == 'hinhThucThanhTraChuyenNganh') {
      state.data.hinhThucThanhTraChuyenNganhInfo.type = e.target.value;
    } else if (name == 'linhVucThanhTraList') {
      state.data.linhVucThanhTraList = e.map(item => item.value);
      state.validLinhVucThanhTra = true;
    } else if (name == 'thucHienPhapLuatVeThanhTraList') {
      state.data.thucHienPhapLuatVeThanhTraList = e.map(item => item.value);
    } else if (name == 'quanHuyenId') {
      if (!e.target.value) {
        state.quanHuyenId = e.target.value;
        state.phuongXaId = '';
        state.dsPhuongXa = [];
      } else {
        state.quanHuyenId = e.target.value;
        state.phuongXaId = '';
        this.getPhuongXa(e.target.value);
      }
    } else if (name == 'phuongXaId') {
      state.phuongXaId = e.target.value;
    }
    else {
      this.setState({
        [name]: e.target.value
      })
    }
    this.setState(state);
  }

  checkValidate() {
    let pass = true;
    this.props.validators['thanhTra'].map(validator => {
      if (pass)
        pass = validator.validate();
      else
        validator.validate();
    });
    return pass;
  }

  addDonVi(arr, value, e) {
    if (arr === 'doiTuongThanhTras' && typeof value != 'undefined') {
      value.preventDefault();
    } else if (arr === 'danhSachDonViPhoiHop' && typeof e != 'undefined') {
      e.preventDefault();
    }
    let newArr = [...this.state[arr]];

    let arrCheck = newArr.filter(state => {
      return state.ten == this.state[value]
    })

    if (this.state[value]) {
      if (arrCheck.length > 0) {
        this.setState({
          [value]: ''
        })
      } else {
        let newItem = {
          ten: this.state[value]
        }
        this.setState({
          [arr]: [
            ...this.state[arr],
            newItem
          ],
          [value]: ''
        })
      }
    }
    return;
  }

  handleChangePageSize(size) {
    this.state.pageData.size = size;
    this.state.pageData.number = 0;
    this.timKiem();
  }
  handlePageClick(page) {
    this.state.pageData.number = page.selected;
    this.timKiem();
  }

  hanldeRemove(index) {
    this.state.doiTuongSelectedList.splice(index, 1);
    this.setState({ ...this.state });
  }

  removeDonVi(arr, index) {
    let newData = [...this.state[arr]];
    newData.splice(index, 1);
    if (arr === 'doiTuongThanhTras' && newData.length > 1) {
      this.state.data.cuocThanhTraNhieuDoiTuong = true;
    } else {
      this.state.data.cuocThanhTraNhieuDoiTuong = false;
    }
    this.setState({
      ...this.state,
      [arr]: newData
    });
  }

  validateSubmitForm() {
    let pass = true;
    this.props.validators['editCuocTT'].map(validator => {
      if (pass)
        pass = validator.validate();
      else {
        validator.validate();
      }
    });
    if (this.state.doiTuongThanhTras.length === 0 && this.state.doiTuongThanhTraImport.length === 0) {
      Toastr(`Phải chọn ít nhất một đối tượng ${this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'}`, 'error');
      pass = false;
    }
    if (this.state.data.chucNangCuocThanhTraInfo.type === 'HANH_CHINH' && isEmpty(this.state.data.linhVucThanhTraList)) {
      this.setState({ validLinhVucThanhTra: false });
      pass = false;
    }
    return pass;
  }

  handleSaveThanhTra() {
    if (this.validateSubmitForm()) {
      let newItem = [...this.state.doiTuongThanhTras];
      let newItems = [...this.state.doiTuongThanhTras];
      let newListDoiTuong = [];
      const { doiTuongSelected } = this.state;
      let getNewItems = [];
      this.state.doiTuongSelectedList.forEach(items => {
        newItem.push({
          id: items.doiTuongThanhTraId,
          ten: items.ten
        });
      });

      let listDV = [];
      if (this.state.danhSachDonViPhoiHop) {
        this.state.danhSachDonViPhoiHop.forEach(item => {
          listDV.push(item.ten);
        });
        this.state.data.donViPhoiHop = listDV.join('; ');
      }

      //hinhThucThanhTraChuyenNganh
      let checkHTTTCN = this.state.hinhThucThanhTraChuyenNganhList.findIndex(item => item.giaTri == this.state.data.hinhThucThanhTraChuyenNganhInfo.type);
      if (checkHTTTCN !== -1) this.state.data.hinhThucThanhTraChuyenNganhInfo.text = this.state.hinhThucThanhTraChuyenNganhList[checkHTTTCN].ten;
      //ChucNangCuocThanhTra
      let checkCNCTT = this.state.dataChucNangCuocThanhTra.findIndex(item => item.giaTri == this.state.data.chucNangCuocThanhTraInfo.type);
      if (checkCNCTT !== -1) this.state.data.chucNangCuocThanhTraInfo.text = this.state.dataChucNangCuocThanhTra[checkCNCTT].ten;
      //get doiTuongThanhTra
      if (this.state.data.cuocThanhTraNhieuDoiTuong === false) {
        let indexItem = this.state.dataDoiTuongThanhTra.findIndex(item => item.doiTuongThanhTraId === get(newItem, '[0].id'))
        if (indexItem !== -1) {
          this.state.data.doiTuongThanhTraInfo = this.state.dataDoiTuongThanhTra[indexItem];
        }
      } else {
        this.state.data.doiTuongThanhTraInfo = null;
        newItems.map(item => {
          let itemIndex = this.state.dataDoiTuongThanhTra.filter(tempItem => { return (tempItem.doiTuongThanhTraId === item.id) || (tempItem.doiTuongThanhTraId === item.doiTuongThanhTraId) });
          if (itemIndex.length > 0) {
            getNewItems.push(itemIndex[0]);
          }
        })
      }

      if (!isEmpty(newItem)) {
        doiTuongSelected.forEach((item) => {
          newItem.forEach(newItem => {
            if (item.doiTuongThanhTraId === newItem.id) {
              newListDoiTuong.push(item);
            }
          });
        });
      }

      let itemParams = {
        // Data import đối tượng thanh tra this.state.doiTuongThanhTraImport
        doiTuongThanhTraImport: this.state.doiTuongThanhTraImport,
        duongDan: this.state.duongDan,
        tenFile: this.state.tenFile,
        cuocThanhTraNhieuDoiTuong: this.state.data.cuocThanhTraNhieuDoiTuong,
        ten: this.state.data.ten ? this.state.data.ten : '',
        tenNhieuDoiTuongThanhTra: this.state.data.tenNhieuDoiTuongThanhTra ? this.state.data.tenNhieuDoiTuongThanhTra : '',
        tenMotDoiTuongThanhTra: this.state.data.tenMotDoiTuongThanhTra ? this.state.data.tenMotDoiTuongThanhTra : '',
        doiTuongThanhTras: newItem,
        doiTuongThanhTrasList: newListDoiTuong,
        donViChuTriId: this.state.data.donViChuTri,
        tenDonViChuTriInfo: this.state.data.donViChuTriInfo.ten ? this.state.data.donViChuTriInfo.ten : '',
        donViPhoiHop: this.state.data.donViPhoiHop ? this.state.data.donViPhoiHop : '',
        kyThanhTra: this.state.kyThanhTra,
        doiTuongThanhTraInfo: this.state.data.doiTuongThanhTraInfo ? this.state.data.doiTuongThanhTraInfo : null,
        thoiGianTienHanh: this.state.data.thoiGianTienHanh ? this.state.data.thoiGianTienHanh : '',
        linhVucThanhTraList: this.state.data.linhVucThanhTraList ? this.state.data.linhVucThanhTraList : null,
        noiDungThanhTra: this.state.noiDungThanhTra,
        kyTruocChuyenSang: this.state.kyTruocChuyenSang || false,
        thoiHanThanhTra: this.state.thoiHanThanhTra ? Number(this.state.thoiHanThanhTra) : 0,
        chucNangCuocThanhTraInfo: this.state.data.chucNangCuocThanhTraInfo ? this.state.data.chucNangCuocThanhTraInfo : {},
        hinhThucThanhTraChuyenNganh: this.state.hinhThucThanhTraChuyenNganhInfo && this.state.hinhThucThanhTraChuyenNganhInfo.type ? this.state.hinhThucThanhTraChuyenNganhInfo.type : null,
        hinhThucThanhTraChuyenNganhInfo: this.state.data.hinhThucThanhTraChuyenNganhInfo ? this.state.data.hinhThucThanhTraChuyenNganhInfo : {},
        thucHienPhapLuatVeThanhTraInfo: this.state.data.thucHienPhapLuatVeThanhTraInfo ? this.state.data.thucHienPhapLuatVeThanhTraInfo : {},
        thucHienPhapLuatVeThanhTra: this.state.data.thucHienPhapLuatVeThanhTraInfo && this.state.data.thucHienPhapLuatVeThanhTraInfo.type ? this.state.data.thucHienPhapLuatVeThanhTraInfo.type : null,
        thucHienPhapLuatVeThanhTraList: this.state.data.thucHienPhapLuatVeThanhTraList ? this.state.data.thucHienPhapLuatVeThanhTraList : null,
        chiTietLinhVuc: this.state.data.chiTietLinhVuc ? this.state.data.chiTietLinhVuc : '',
      };
      this.props.saveThanhTra(itemParams);

      // dataDoiTuongThanhTras
      this.setState({
        noiDungThanhTra: '',
        thucHienPhapLuatVeThanhTra: '',
        hinhThucThanhTraChuyenNganh: '',
        danhSachDonViPhoiHop: [],
        kyTruocChuyenSang: false,
        doiTuongThanhTraImport: [],
        duongDan: '',
        tenFile: '',
        donViPhoiHop: '',
        donViChuTriInfo: {
          coQuanQuanLyId: null,
          ten: ''
        },
        isOpenThanhTra: false,
        chucNangKeHoachThanhTra: '',
        doiTuongThanhTras: [],
        data: {
          ten: '',
          doiTuongThanhTras: [],
          doiTuongThanhTra: '',
          tenNhieuDoiTuongThanhTra: '',
          thoiGianTienHanh: '',
          cuocThanhTraNhieuDoiTuongList: {
            text: `${this.checkIsKiemTra() ? 'Kiểm tra' : 'Thanh tra'} nhiều đối tượng`,
            type: 'true'
          },
          chucNangCuocThanhTraInfo: {
            text: 'Hành Chính',
            type: 'HANH_CHINH'
          },
          linhVucThanhTraList: [],
          thucHienPhapLuatVeThanhTraList: [],
          chiTietLinhVuc: '',
          hinhThucThanhTraChuyenNganhInfo: {
            text: '',
            type: ''
          },
          donViChuTri: this.userInfo.donViId,
          tenDonViChuTriInfo: this.userInfo.tenCoQuanQuanLy,
          donViChuTriInfo: {
            coQuanQuanLyId: this.userInfo.donViId,
            ten: this.userInfo.tenCoQuanQuanLy
          },
        },
        thoiHanThanhTra: '',
        kyThanhTra: '',
        linhVucId: '',
        nhomDoiTuongThanhTraId: '',
        tuKhoa: '',
        pageData: {
          number: 0,
          size: 10,
          totalElements: 0
        },
        ketQuaTimKiemList: [],
        tableLoading: false,
        doiTuongSelectedList: [],
        checkAll: false,
        totalSelectedList: []
      })
    }
  }

  handleSave() {
    let newItem = [...this.state.doiTuongThanhTras];
    const newTempDoiTuongSelected = [...this.state.newTempDoiTuongSelected];
    this.state.doiTuongSelectedList.forEach(items => {
      newItem.push({
        id: items.doiTuongThanhTraId,
        ten: items.ten,
      });
    });
    if (newItem.length > 1) {
      this.state.data.cuocThanhTraNhieuDoiTuong = true;
    } else {
      this.state.data.cuocThanhTraNhieuDoiTuong = false;
    }
    this.setState({
      doiTuongSelected: newTempDoiTuongSelected,
      doiTuongThanhTras: newItem,
      isOpen: false,
    })
    this.state.doiTuongSelectedList = [];
  }

  kiemTraTenDoiTuong(idDoiTuong, check) {
    let d = new Date();
    let getNam = d.getFullYear() + 1;
    let getTenDoiTuong = '';
    ThanhTra.actions.getKiemTraDoiTuongTT.request({
      doiTuongThanhTraId: idDoiTuong,
      namThanhTra: getNam
    }).then(res => {
      if (res && res.data) {
        let idPushCoQuan = [];
        res.data._embedded.coQuanQuanLies.map(items => {
          idPushCoQuan.push(items.ten)
        })
        const tenDoituong = this.state.ketQuaTimKiemList.find(items => items.doiTuongThanhTraId === idDoiTuong);
        if (this.state.checked && check) {
          this.setState({
            isOpenDT: true,
            getTenDoiTuong: get(tenDoituong, 'ten'),
            idPushCoQuan: idPushCoQuan
          });
        }
        if (check === false) {
          let msgWarning = `Đối tượng ${this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'} ` + getTenDoiTuong + ` đã được chọn làm đối tượng ${this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'} tại đơn vị: ` + idPushCoQuan;
          Toastr(msgWarning, 'thongbao');
        }
      }
    })
    return 0;
  }

  async handleSelectedDoiTuong(item) {
    let check = true;
    item.selected = !item.selected;
    if (item.selected) {
      let newtotalSelectedList = [...this.state.totalSelectedList];
      let newTempDoiTuongSelected = [...this.state.newTempDoiTuongSelected];
      if (item.daTrung === true) {
        this.setState({
          doiTuongThanhTraId: item.doiTuongThanhTraId
        });
      }
      newTempDoiTuongSelected.push(item);
      newtotalSelectedList.push(item);
      await this.setState({
        checked: item.selected,
        totalSelectedList: newtotalSelectedList,
        newTempDoiTuongSelected
      });
      this.kiemTraTenDoiTuong(item.doiTuongThanhTraId, check);
    } else {
      let newtotalSelectedList = [...this.state.totalSelectedList];
      let newTempDoiTuongSelected = [...this.state.newTempDoiTuongSelected];
      newtotalSelectedList.map((value, index) => {
        if (value.doiTuongThanhTraId == item.doiTuongThanhTraId) {
          newtotalSelectedList.splice(index, 1);
          newTempDoiTuongSelected.splice(index, 1);
        }
      });
      Toastr(null, 'resetclear');
      this.setState({
        newTempDoiTuongSelected,
        totalSelectedList: newtotalSelectedList
      });
    }
  }

  handleSelectedAll() {
    let check = false;
    this.state.checkAll = !this.state.checkAll;
    this.state.ketQuaTimKiemList.map((item) => {
      item.selected = this.state.checkAll;
      if (this.state.checkAll) {
        this.state.totalSelectedList.push(item);
        this.kiemTraTenDoiTuong(item.doiTuongThanhTraId, check);
      } else {
        this.state.totalSelectedList = [];
        Toastr(null, 'resetclear');
      }
    });
    this.setState({ ...this.state });
  }

  themVaoCuocTT() {
    this.state.doiTuongSelectedList = [...this.state.doiTuongSelectedList, ...this.state.totalSelectedList];
    this.state.totalSelectedList = [];
    this.setState({ ...this.state });
    this.timKiem();
  }
  getChucNangCuocThanhTra() {
    ThanhTra.actions.getChucNangCuocThanhTra.request().then(res => {
      if (res.data) {
        this.setState({
          dataChucNangCuocThanhTra: res.data
        });
      }
    })
  }

  closeDialogDT(name) {
    let state = this.state;
    let newtotalSelectedList = [...this.state.totalSelectedList];
    let newketQuaTimKiemList = [...this.state.ketQuaTimKiemList];
    if (this.state.doiTuongThanhTraId) {
      newtotalSelectedList.map((value, index) => {
        if (value.doiTuongThanhTraId == this.state.doiTuongThanhTraId) {
          newtotalSelectedList.splice(index, 1);
        }
      });
    }
    newketQuaTimKiemList.map(item => {
      if (item.doiTuongThanhTraId === this.state.doiTuongThanhTraId) {
        item.selected = false;
      }
    });
    state.isOpenDT = false;
    this.setState({
      totalSelectedList: newtotalSelectedList,
      ketQuaTimKiemList: newketQuaTimKiemList,
      isOpenDT: false
    });
  }

  openDialogDT() {
    this.setState({
      isOpenDT: true
    });
  }

  onCloseDT() {
    this.setState({
      isOpenDT: false
    });
  }

  uploadFile(e) {
    if (this.refs.btnUpload.files[0]) {
      const fileName = this.refs.btnUpload.files[0].name;
      const ext = fileName.split('.').pop().toLowerCase();
      const fileSize = e.target.files[0].size;
      const listExcel = ['xls', 'xlsx']
      if (!includes(listExcel, ext)) {
        Toastr(msg.fileExcel, 'warning');
      } else if (fileSize > LimitFileSize * 1024 * 1024) {
        Toastr(msg.fileSizeErr, 'warning');
      } else if (fileSize == 0) {
        Toastr(msg.fileSizeNull, 'warning');
      } else {
        let params = { field: 'file', file: this.refs.btnUpload.files[0] };

        params.progress = (progress) => {
          const progressBar = Math.round((progress.loaded * 100) / progress.total);

          this.setState({ progress: progressBar });
        }
        Reception.actions.postFileUpload.request('', params).then(res => {
          let checkURL = '';
          if (res && res.data && !checkServerLive) {
            checkURL = res.data;
          } else if (res && res.data && checkServerLive) {
            checkURL = res.data.id;
          }
          this.setState({
            ...this.state,
            progress: 0,
            tenFile: fileName,
            duongDan: checkURL,
            isError: false
          }, () => {
            this.addDoiTuongThanhTra(params)
          });
        }).catch(error => {
          this.setState({
            progress: 0,
            isError: true
          });
        });
      }
    }
  }

  addDoiTuongThanhTra(params) {
    this.setState({
      loadingImport: true
    });
    Reception.actions.importFileDoiTuong.request('', params).then(res => {
      if (!isEmpty(res.data)) {
        const { doiTuongThanhTraExists, numberUnsuccess, doiTuongThanhTraNotExists } = res.data;

        this.setState({
          // doiTuongThanhTraImport: doiTuongThanhTraExists.map(item => ({ id: item.id })),
          errorImport: false,
          data: {
            ...this.state.data,
            cuocThanhTraNhieuDoiTuong: doiTuongThanhTraExists.length > 1 || this.state.data.cuocThanhTraNhieuDoiTuong
          },
          base64Content: get(doiTuongThanhTraNotExists, 'base64Content') || '',
          fileName: get(doiTuongThanhTraNotExists, 'fileName') || '',
          mineType: get(doiTuongThanhTraNotExists, 'mineType') || '',
          numberUnsuccess: numberUnsuccess,
          doiTuongThanhTras: [...this.state.doiTuongThanhTras, ...doiTuongThanhTraExists]
        });
      }
    }).catch(error => {
      const message = get(error, 'response.data.errors[0].description');
      this.setState({
        errorImport: true,
        duongDan: '',
        tenFile: '',
        data: {
          ...this.state.data,
          cuocThanhTraNhieuDoiTuong: false
        }
      }, () => {
        Toastr(message, 'error');
      });
    }).finally(() => {
      this.setState({
        loadingImport: false,
        isOpenThongBao: this.state.numberUnsuccess > 0
      });
    });
  }

  convertEndCode(data) {
    const result = encodeURIComponent(data);
    return result;
  }

  handleExport() {
    const URL = String(API_URL) + "/doi-tuong-thanh-tra/download-import-template"
    exportExcel(URL, 'import-template.xlsx');
  }

  checkIsKiemTra() {
    const result = window.location.pathname.includes('kiem-tra') || get(this.props, 'isKiemTra');
    return result;
  }

  render() {
    let checkKeHoach = this.props.keHoach;
    let tenTieuDe = `Thêm mới cuộc ${this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'}`;
    let tenTDFull = '';
    if (checkKeHoach) {
      tenTieuDe = `Bổ sung KH${this.checkIsKiemTra() ? 'KT' : 'TT'}`;
      tenTDFull = `Bổ sung kế hoạch ${this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'}`;
    }
    return (
      <div className='reception-container'>
        <Link className="btn-green btn-pullright" onClick={this.openDialogThanhTra.bind(this)}><i className="tt tt-addfile"></i>{tenTieuDe}</Link>
        <Dialog
          isOpen={this.state.isOpenDT}
          onClose={this.closeDialogDT.bind(this, 'isOpenDT')}
          title='Thông báo'
          className="reception-dialog delete-dialog wrap-block"
        >
          <div className="pt-dialog-body mb0 hlDialog">
            <div className='pt10 txt-center'>
              {`Đối tượng ${this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'}`}
              <h2>{` "${this.state.getTenDoiTuong}" `}</h2>
              {`đã được chọn làm đối tượng ${this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'} của`} {' '}
              {this.state.idPushCoQuan.join(', ')}
            </div>
            <div className='pb20 txt-center'>
              Bạn có đồng ý thêm
              <h2>{` "${this.state.getTenDoiTuong}" `}</h2>
              <span>{`vào kế hoạch ${this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'} không?`}</span>
            </div>
          </div>
          <div className="box-bottom col-100">
            <Link className="btn-action btn-close action-todo" onClick={this.closeDialogDT.bind(this)}><span>Không</span></Link>
            <Link className="btn-action btn-green action-todo" onClick={this.onCloseDT.bind(this)}><span>Đồng ý</span></Link>
          </div>
        </Dialog>
        <Dialog
          isOpen={this.state.isOpenThanhTra}
          onClose={this.closeDialog.bind(this, 'isOpenThanhTra')}
          title={checkKeHoach ? tenTDFull : `Thêm mới cuộc ${this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'}`}
          className="dialog-them-moi-dttt dialog-default wrap-block"
        >
          <section className='wrap-block'>
            <div className='row pl15 pr15'>
              <h2 className='title-14 p20'></h2>
            </div>
            <div className='row pl30 pr30'>
              <form className='wrap-tt-dvph col-100 no-gutter' onSubmit={this.addDonVi.bind(this, 'doiTuongThanhTras')}>
                <TextArea triggerOnblur={true} label={`Tên cuộc ${this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'}`} className='col-100' value={this.state.data.ten} onChange={this.onChange.bind(this, 'ten')} name='ten' require={true} bindValidator={this} channel='editCuocTT' maxLength={500} />
                <div>
                  <div className="wrap-input-tt-dvph col-25 mrt22">
                    <Link className="col-100 no-gutter btn-green btn-pullleft" onClick={this.openDialog.bind(this)}><i className="tt tt-addfile"></i>Đối tượng {this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'}</Link>
                  </div>
                  {/* {
                    this.state.data.cuocThanhTraNhieuDoiTuong === true &&
                    <div className="wrap-input-tt-dvph col-25 mrt22">
                      <Input placeholder={`Tên đối tượng ${this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'}...`} value={this.state.data.tenNhieuDoiTuongThanhTra} onChange={this.onChange.bind(this, 'tenNhieuDoiTuongThanhTra')} name='tenNhieuDoiTuongThanhTra' className="col-55" require={true} bindValidator={this} channel="editCuocTT" />
                    </div>
                  } */}
                  <div className="wrap-input-tt-dvph col-25 mrt22">
                    <div className="upload_file_content pt10">
                      <input type="file" name="uploadFile" className="upload btn-green btn-pullleft" ref='btnUpload' onChange={this.uploadFile.bind(this)} />
                      <span htmlFor="file">{isEmpty(this.state.duongDan) && !this.state.errorImport ? 'Tải lên Danh sách đối tượng' : 'Tải lại danh sách đối tượng'}</span>
                    </div>
                  </div>
                  <div className="col-25 mrt22">
                    <div className="download_file_content pt10 download-example-file" onClick={this.handleExport.bind(this)}>
                      <span>Tải file mẫu</span>
                    </div>
                  </div>
                  <div className='wrap-input-tt-dvph col-25 mrt22'>
                    {
                      checkServerLive && !this.state.errorImport && !this.state.loadingImport &&
                      <Link className="txt-blue txt-underline" onClick={() => { downloadFile(this.state.duongDan, this.state.tenFile) }}>{this.state.tenFile}</Link>
                    }
                    {
                      !checkServerLive && !this.state.errorImport && !this.state.loadingImport &&
                      <Link className="txt-blue txt-underline" onClick={downloadExcel.bind(this, this.state.duongDan, this.state.tenFile)}>{this.state.tenFile}</Link>
                    }
                    {
                      this.state.loadingImport &&
                      <span className='icon-loader mt10'></span>
                    }
                  </div>
                  <div className='col-100 mb18'>
                    <div className='ds-tt-dvph'>
                      {
                        this.state.doiTuongThanhTras.map((item, i) => {
                          return (
                            <div className='tt-dvph-item' key={i}>
                              <span className="tt-dvph-icon" onClick={this.removeDonVi.bind(this, 'doiTuongThanhTras', i)}>×</span>
                              <span className="tt-dvph-value">{item.ten}</span>
                            </div>
                          )
                        })
                      }
                    </div>
                  </div>
                </div>
              </form>
              <DropDownMulipleUse label={`Hoạt động ${this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'}`} keyName='giaTri' confirm={true} placeholder={null} valueName='ten' className='col-25' data={this.state.dataChucNangCuocThanhTra} selectedValue={this.state.data.chucNangCuocThanhTraInfo ? this.state.data.chucNangCuocThanhTraInfo.type : ''} onChange={this.onChange.bind(this, 'chucNangCuocThanhTra')} name='chucNangCuocThanhTra' />
              <div className='row pl30 pr30'>
                <ShowIf condition={this.state.data.chucNangCuocThanhTraInfo != null && this.state.data.chucNangCuocThanhTraInfo.type == 'HANH_CHINH'}>
                  <DropDownChonLinhVucThanhTraMultiple
                    label={`Lĩnh vực ${this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'}`}
                    confirm={true}
                    placeholder={null}
                    className='col-25'
                    data={this.state.dataLinhVucThanhTra.map(item => ({
                      label: item.ten,
                      value: item.giaTri
                    }))}
                    selectedValue={this.state.linhVucThanhTraList}
                    onChange={this.onChange.bind(this, 'linhVucThanhTraList')}
                    name='linhVucThanhTraList'
                    require
                    validLinhVucThanhTra={this.state.validLinhVucThanhTra}
                  />
                </ShowIf>
                {
                  this.state.data.chucNangCuocThanhTraInfo != null && this.state.data.chucNangCuocThanhTraInfo.type == 'CHUYEN_NGANH' &&
                  <DropDown className='col-25' label={`Hình thức ${this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'} chuyên ngành`} placeholder options={this.state.hinhThucThanhTraChuyenNganhList} keyName="giaTri" valueName="ten" selectedValue={this.state.data.hinhThucThanhTraChuyenNganhInfo ? this.state.data.hinhThucThanhTraChuyenNganhInfo.type : ''} onChange={this.onChange.bind(this, 'hinhThucThanhTraChuyenNganh')} name='hinhThucThanhTraChuyenNganh' bindValidator={this} channel='editCuocTT' require />
                }
                <ShowIf condition={(this.state.data.chucNangCuocThanhTraInfo != null && this.state.data.chucNangCuocThanhTraInfo.type == 'HANH_CHINH' && this.state.data.linhVucThanhTraList.includes('THANH_TRA_TRACH_NHIEM'))}>
                  <DropDownMultipleSelect
                    label=" "
                    className='col-25 mt16'
                    bindValidator={this}
                    channel="formTaoDon"
                    value={this.state.thucHienPhapLuatVeThanhTraList}
                    options={this.state.thucHienPhapLuatVeThanhTraListCombobox.map(item => ({
                      label: item.ten,
                      value: item.giaTri
                    }))}
                    onChange={this.onChange.bind(this, 'thucHienPhapLuatVeThanhTraList')}
                    placeholder=''
                    closeMenuOnSelect={false}
                  />
                </ShowIf>
                <ShowIf condition={(this.state.data.chucNangCuocThanhTraInfo != null && this.state.data.chucNangCuocThanhTraInfo.type == 'HANH_CHINH')}>
                  <Input
                    className="col-25"
                    label="Chi tiết lĩnh vực"
                    placeholder="Nhập..."
                    value={this.state.chiTietLinhVuc}
                    onChange={this.onChange.bind(this, 'chiTietLinhVuc')}
                    name='chiTietLinhVuc'
                    bindValidator={this}
                    channel='formTaoDon'
                    maxLength={255}
                  />
                </ShowIf>
              </div>
            </div>
            <div className='row pl30 pr30'>
              <Input label={`Thời kỳ ${this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'}`} value={this.state.kyThanhTra} onChange={this.onChange.bind(this, 'phamViThanhTra')} name='phamViThanhTra' className="col-25" require={true} bindValidator={this} channel="editCuocTT" />
              <InputNumber label="Thời hạn (ngày)" value={this.state.thoiHanThanhTra} onChange={this.onChange.bind(this, 'thoiHanThanhTra')} name='thoiHanThanhTra' className="col-25" />
              <Input label="Thời gian tiến hành" value={this.state.data.thoiGianTienHanh} onChange={this.onChange.bind(this, 'thoiGianTienHanh')} name='thoiGianTienHanh' className="col-25" maxLength={255} />
              {/* <Checkbox className='col-100' name="checkDonViPhoiHop" checked={this.state.checkDonViPhoiHop || false} onChange={this.changeCheckbox.bind(this)}>
                  <span className="span-checkbox span-position-label">Đơn vị phối hợp</span>
                </Checkbox> */}
              <TextArea className='col-100' label={`Nội dung ${this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'}`} value={this.state.noiDungThanhTra} onChange={this.onChange.bind(this, 'noiDungThanhTra')} name='noiDungThanhTra' rows={3} placeholder='Nhập...' require={true} bindValidator={this} channel="editCuocTT" maxLength={500} />
              {/* <DropDownTreeSelectOneElement label="Đơn vị chủ trì" className='col-25' placeholder dataOptions={this.state.dataDonViChuTri} value={this.state.data.donViChuTri} onChange={this.onChange.bind(this, 'donViChuTri')} name='donViChuTri' propertyChildren='coQuanQuanLyCha' propertyParent='coQuanQuanLyId' require={true} bindValidator={this} channel="editCuocTT"/> */}

              {/* <form className='wrap-tt-dvph col-100 no-gutter' onSubmit={this.addDonVi.bind(this, 'danhSachDonViPhoiHop', 'donViPhoiHop')}>
                  <div className='wrap-input-tt-dvph col-25'>
                    <Input label='Đơn vị phối hợp' placeholder='Nhập...' className='col-100 no-gutter' value={this.state.donViPhoiHop} onChange={this.onChange.bind(this, 'donViPhoiHop')} name='donViPhoiHop'/>
                    <button className='btn-add-dvph' type='submit'></button>
                  </div>
                  <div className='col-75 mb18'>
                    <div className='ds-tt-dvph'>
                      {
                        this.state.danhSachDonViPhoiHop.map((item,i) => {
                          return (
                            <div className='tt-dvph-item' key={i}>
                              <span className="tt-dvph-icon" onClick={this.removeDonVi.bind(this, 'danhSachDonViPhoiHop', i)}>×</span>
                              <span className="tt-dvph-value">{item.ten}</span>
                            </div>
                          )
                        })
                      }
                    </div>
                  </div>
                </form> */}
            </div>
          </section>
          <div className='row pl15 pr15'>
            <span className='line-border mt5 mb0'></span>
          </div>
          <div className="action-form-wrap pt20">
            <div className="box-bottom">
              <Link className="btn-action btn-close" onClick={this.closeDialog.bind(this, 'isOpenThanhTra')}><span>Đóng</span></Link>
              <Link
                className={classnames('btn-action btn-save', {
                  'btn-loading-inline': this.state.loadingImport
                })}
                onClick={this.handleSaveThanhTra.bind(this)}
              >
                <span>Lưu</span>
              </Link>
            </div>
          </div>
        </Dialog>

        <Dialog
          isOpen={this.state.isOpen}
          onClose={this.closeDialog.bind(this, 'isOpen')}
          title={`Thêm đối tượng ${this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'}`}
          className="dialog-them-moi-dttt dialog-default wrap-block"
        >
          <div className='row pl30 pr30'>
            <div className='col-100'>
              <h2 className='title-14 pt20 pb15'>{`1. Tìm kiếm đối tượng ${this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'}`}</h2>
            </div>
            <Input className='col-28' label="Đối tượng" value={this.state.tuKhoa} onChange={this.onChangeTuKhoa.bind(this)} name='tuKhoa' placeholder='Nhập tên đối tượng...' />
            <Input className='col-28' label='Mã số thuế' value={this.state.maSoThue} onChange={this.onChangeMaSoThue.bind(this)} name='maSoThue' placeholder='Nhập mã số thuế...' />
            <DropDown
              className='col-28'
              label="Nhóm đối tượng"
              selectedValue={this.state.nhomDoiTuongThanhTraId}
              onChange={this.onChange.bind(this, 'nhomDoiTuongThanhTraId')}
              name='nhomDoiTuongThanhTraId'
              placeholder
              options={this.state.nhomDTList} keyName="nhomDoiTuongThanhTraId" valueName="ten"
            />
            <DropDown
              className='col-28'
              label="Huyện/TP"
              selectedValue={this.state.quanHuyenId}
              onChange={this.onChange.bind(this, 'quanHuyenId')}
              name='quanHuyenId'
              placeholder
              options={this.state.dsQuanHuyen} keyName="donViHanhChinhId" valueName="ten"
            />
            <DropDown
              className='col-28'
              label="Phường/Xã"
              selectedValue={this.state.phuongXaId}
              onChange={this.onChange.bind(this, 'phuongXaId')}
              name='phuongXaId'
              placeholder
              options={this.state.dsPhuongXa} keyName="donViHanhChinhId" valueName="ten"
            />
            <Input className='col-28' label="Địa chỉ" value={this.state.diaChi} onChange={this.onChangeDiaChi.bind(this)} name='diaChi' placeholder='Nhập' />
            <div className='col-15 mt22'>
              <Link className='btn-green ml10' onClick={this.timKiem.bind(this, true)}>
                <i className='tt-search'></i>Tìm kiếm
              </Link>
            </div>
          </div>

          <div className='row pl10 pr10 '>
            <div className='col-100'>
              <h2 className='title-14 pt15 pb15 pr20 pl20'>1.1 Kết quả tìm kiếm</h2>
            </div>
            <div className='pl5 pr5'>
              <DataTableMultipleSelect onDisableCheck onCheck={this.handleSelectedAll.bind(this)} selectAllStatus={this.state.checkAll} header={header.thanhTra.KQTKTMDTTT2} dataList={this.state.ketQuaTimKiemList} tableLoading={this.state.tableLoading} pageData={this.state.pageData} parent={this}>
                <RowItemKetQuaTimKiemThanhTra />
              </DataTableMultipleSelect>
            </div>
            <div className='col-100 pb20 pt10 txt-center'>
              <Link className="btn-green" onClick={this.themVaoCuocTT.bind(this)}>
                <i className="tt tt-addfile"></i>{`Thêm vào cuộc ${this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'}`}
              </Link>
            </div>
          </div>
          <div className='row pl10 pr10 '>
            <div className='row pl40 pr40'>
              <span className='line-border mt5 mb0'></span>
            </div>
            <div className='col-100'>
              <h2 className='title-14 pt15 pb15 pr20 pl20'>{`1.2 Danh sách đối tượng sẽ được thêm vào cuộc ${this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'}`}</h2>
            </div>
            <div className='pl5 pr5'>
              <DataTable header={header.thanhTra.TMDTTT2} dataList={this.state.doiTuongSelectedList} hideButtonExport={true} hidePagination={true} parent={this} emptyMsg="Chưa có đối tượng được thêm vào cuộc thanh tra">
                <RowItemDanhSachThemMoiThanhTra />
              </DataTable>
            </div>
          </div>
          <div className='row pl15 pr15'>
            <span className='line-border mt5 mb0'></span>
          </div>
          <div className="action-form-wrap pt20">
            <div className="box-bottom">
              <Link className="btn-action btn-close" onClick={this.closeDialog.bind(this, 'isOpen')}><span>Đóng</span></Link>
              <Link className="btn-action btn-save" onClick={this.handleSave.bind(this)}><span>Lưu</span></Link>
            </div>
          </div>
        </Dialog>
        <Dialog
          isOpen={this.state.isOpenThongBao}
          onClose={this.closeDialogThongBao.bind(this)}
          title={'Thông báo'}
          className="panel-popup category">
          <div className="pt-dialog-body">
            {`Danh sách đối tượng ${this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'} vừa tải lên có`}
            <a className="txt-underline" download={this.state.fileName} href={`data:${this.state.mineType};base64,${this.state.base64Content}`}> {this.state.numberUnsuccess} </a>
            đối tượng chưa có trong hệ thống. Vui lòng bấm vào link Số đối tượng để tải xuống và kiểm tra lại
          </div>
          <div className="pt-dialog-footer">
            <Link onClick={this.closeDialogThongBao.bind(this)} className="btn-action btn-close" >
              <span>Đóng</span>
            </Link>
          </div>
        </Dialog>
      </div>
    );
  }
}

ThemMoiDoiTuongThanhTra.defaultProps = {
  validators: []
}

export default ThemMoiDoiTuongThanhTra;



// WEBPACK FOOTER //
// ./src/components/modules/thanh-tra/sub-view/ThemMoiDoiTuongThanhTra.jsx